import { Route, Routes } from 'react-router-dom';

// ============================================================
// PUBLIC PAGES
// ============================================================

import Home from '../pages/Home';

import ForgotPassword from '../pages/ForgotPassword';
import ResetAccount from '../pages/ResetAccount';
import SigninPage from '../pages/SigninPage';
import SignupPage from '../pages/SignupPage';

import BusinessRulesPage from '../pages/BusinessRulesPage';
import ConditionsGenerales from '../pages/ConditionsGenerales';
import Cookies from '../pages/Cookies';
import HelpPage from '../pages/HelpPage';
import HowItWorksPage from '../pages/HowItWorksPage';
import Privacy from '../pages/Privacy';
import RentalConditions from '../pages/RentalConditions';
import ReservationStatesPage from '../pages/ReservationStatesPage';
import Terms from '../pages/terms';

import SearchResultPage from '../pages/SearchResultPage';
import VoitureProfilePage from '../pages/VoitureProfilePage';

import StripeRefresh from '../pages/StripeRefresh';
import StripeSuccess from '../pages/StripeSuccess';

// ============================================================
// AUTHENTICATION
// ============================================================

import AdminPrivateRoute from '../utils/AdminPrivateRoute';
import PrivateRoute from '../utils/PrivateRoute';

// ============================================================
// ACCOUNT / USER
// ============================================================

import AccountDemande from '../pages/AccountDemandes';
import AccountEarnings from '../pages/AccountEarnings';
import AccountPerformances from '../pages/AccountPerformances';
import AccountSetting from '../pages/AccountSetting';
import AccountVoitures from '../pages/AccountVoitures';

import Earnings from '../pages/Earnings';
import Locations from '../pages/Locations';

import FavoritesPage from '../pages/FavoritesPage';
import GuestSetting from '../pages/GuestSetting';

import GuestReservationPage from '../pages/GuestReservationsPage';
import GuestReviewsPage from '../pages/GuestReviewsPage';

import InboxListPage from '../pages/InboxListPage';

import InboxMessagePage from '../pages/InboxMessagePage/InboxMessagePage';
// ============================================================
// VEHICLES / LISTINGS
// ============================================================

import AdvancedConfigPage from '../pages/AdvancedConfigPage';
import AvailabilitiesCar from '../pages/AvailabilitiesCar';
import CompleteAnnoncePage from '../pages/CompleteAnnoncePage';
import EmplacementCarDelivery from '../pages/EmplacementCarDelivery';
import LocationModeCar from '../pages/LocationModeCar';
import VoitureConfigPage from '../pages/VoitureConfigPage';

import EditPhotosVoitures from '../pages/EditPhotosVoitures';
import SettingAvailabilities from '../pages/SettingAvailabilities';
import VehiculeSettings from '../pages/VehiculeSettings';

import LouerVoiturePage from '../pages/LouerVoiturePage';

import LocationDelivery from '../pages/LocationDelivery';
import PreferencesReservation from '../pages/PreferencesReservation';
import PriceAndReduction from '../pages/PriceAndReduction';

import VoituresCalendar from '../pages/VoituresCalendar';

// ============================================================
// RESERVATIONS / PAYMENTS
// ============================================================

import ChatBoxReservation from '../pages/ChatBoxReservation';
import PaymentReceipt from '../pages/PaymentReceipt';
import ReservationGuest from '../pages/ReservationGuest';
import ReservationPage from '../pages/ReservationPage';

import CheckoutPage from '../pages/CheckoutPage';
import OnboardingCheckout from '../pages/OnboardingCheckout';

// ============================================================
// CALENDAR
// ============================================================

import Calendar from '../components/CalendarItem';

// ============================================================
// ADMIN
// ============================================================

import AdminAnnonces from '../pages/AdminAnnonces';
import AdminAnnoncesItemPage from '../pages/AdminAnnoncesItemPage';
import AdminLogin from '../pages/AdminLogin';
import AdminPaiements from '../pages/AdminPaiements';
import AdminReportsPage from '../pages/AdminReportsPage';
import AdminResaItemPage from '../pages/AdminResaItemPage';
import AdminReservations from '../pages/AdminReservationsPage';
import AdminUserItemPage from '../pages/AdminUserItemPage';
import AdminUsers from '../pages/AdminUsers';
import AnnonceExpressPage from '../pages/AnnonceExpressPage';
import EmailVerification from '../pages/EmailVerification';
import RecommendationsPage from '../pages/RecommendationsPage';
import Unaivalabities from '../pages/Unaivalabities';

// ============================================================
// ROUTES
// ============================================================

function AppRoutes() {
  return (
    <Routes>
      {/* ======================================================
          PUBLIC
          ====================================================== */}
      <Route path="/" element={<Home />} />
      <Route path="/signin" element={<SigninPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/reset-password/:token" element={<ResetAccount />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/email-verification" element={<EmailVerification />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/help" element={<HelpPage />} />
      <Route path="/conditions-generales" element={<ConditionsGenerales />} />
      <Route path="/regles-business" element={<BusinessRulesPage />} />
      <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
      <Route path="/etats-reservation" element={<ReservationStatesPage />} />
      <Route path="/help/conditions-de-locations" element={<RentalConditions />} />
      <Route path="/rental-conditions" element={<RentalConditions />} />
      <Route path="/location-voiture/:annonceid" element={<VoitureProfilePage />} />
      p
      <Route path="/search" element={<SearchResultPage />} />
      <Route path="/business/earnings" element={<AccountEarnings />} />
      <Route path="/account-public" element={<AccountDemande />} />
      <Route path="/account/voitures-public" element={<AccountVoitures />} />
      <Route path="/account/asks" element={<AccountDemande />} />
      <Route
        path="/account/voiture/prix-et-reductions/:vehiculeId"
        element={<PriceAndReduction />}
      />
      <Route path="/stripe/success" element={<StripeSuccess />} />
      <Route path="/stripe/refresh" element={<StripeRefresh />} />
      {/* ======================================================
          AUTHENTICATED USER
          ====================================================== */}
      <Route
        path="/confirmmodel/:voitureId"
        element={<PrivateRoute Component={VoitureConfigPage} />}
      />
      <Route
        path="/emplacement-delivery-car/:voitureId/annonce/:annonceId"
        element={<PrivateRoute Component={EmplacementCarDelivery} />}
      />
      <Route
        path="/location-mode-car/:voitureId/annonce/:annonceId"
        element={<PrivateRoute Component={LocationModeCar} />}
      />
      <Route
        path="/availabilities-car/:voitureId"
        element={<PrivateRoute Component={AvailabilitiesCar} />}
      />
      <Route
        path="/unavailabilities-car/:voitureId/calendar/:mois"
        element={<PrivateRoute Component={Unaivalabities} />}
      />
      <Route
        path="/advancedconfig/:voitureId"
        element={<PrivateRoute Component={AdvancedConfigPage} />}
      />
      <Route path="/completeAnnonce" element={<PrivateRoute Component={CompleteAnnoncePage} />} />
      <Route path="/annonce-express" element={<PrivateRoute Component={AnnonceExpressPage} />} />
      <Route path="/recommendations" element={<PrivateRoute Component={RecommendationsPage} />} />
      <Route
        path="/account/your-car/edit-photos/:vehiculeId"
        element={<PrivateRoute Component={EditPhotosVoitures} />}
      />
      <Route
        path="/account/settings/availabilities/:vehiculeId"
        element={<PrivateRoute Component={SettingAvailabilities} />}
      />
      <Route path="/account" element={<PrivateRoute Component={AccountDemande} />} />
      <Route path="/account/demandes" element={<PrivateRoute Component={AccountDemande} />} />
      <Route path="/account/locations" element={<PrivateRoute Component={Locations} />} />
      <Route path="/account/voitures" element={<PrivateRoute Component={AccountVoitures} />} />
      <Route
        path="/account/performances"
        element={<PrivateRoute Component={AccountPerformances} />}
      />
      <Route path="/account/settings" element={<PrivateRoute Component={AccountSetting} />} />
      <Route path="/inbox/messages" element={<PrivateRoute Component={InboxListPage} />} />
      <Route
        path="/inbox/messages/thread/:messageid"
        element={<PrivateRoute Component={InboxMessagePage} />}
      />
      <Route path="/location-voiture" element={<PrivateRoute Component={LouerVoiturePage} />} />
      <Route path="/onboarding" element={<PrivateRoute Component={OnboardingCheckout} />} />
      <Route path="/checkout" element={<PrivateRoute Component={CheckoutPage} />} />
      <Route path="/earnings" element={<PrivateRoute Component={Earnings} />} />
      <Route
        path="/guest/listing/reservations"
        element={<PrivateRoute Component={GuestReservationPage} />}
      />
      <Route
        path="/guest/listing/reviews"
        element={<PrivateRoute Component={GuestReviewsPage} />}
      />
      <Route path="/calendar/:mois" element={<PrivateRoute Component={Calendar} />} />
      <Route
        path="/account/voiture/:vehiculeId/calendar/:mois"
        element={<PrivateRoute Component={VoituresCalendar} />}
      />
      <Route
        path="/account/settings/vehicule/:vehiculeId"
        element={<PrivateRoute Component={VehiculeSettings} />}
      />
      <Route
        path="/account/voiture/emplcaments-et-livraison/:vehiculeId/annonce/:AnnonceId"
        element={<PrivateRoute Component={LocationDelivery} />}
      />
      <Route
        path="/account/voiture/preferences-de-reservation/:vehiculeId"
        element={<PrivateRoute Component={PreferencesReservation} />}
      />
      <Route
        path="/reservation/:reservationId"
        element={<PrivateRoute Component={ReservationPage} />}
      />
      <Route
        path="/guest/reservation/:reservationId"
        element={<PrivateRoute Component={ReservationGuest} />}
      />
      <Route
        path="/guest/reservation/:reservationId/receipt"
        element={<PrivateRoute Component={PaymentReceipt} />}
      />
      <Route
        path="/guest/chatbox/:reservationId"
        element={<PrivateRoute Component={ChatBoxReservation} />}
      />
      <Route path="/guest/settings" element={<PrivateRoute Component={GuestSetting} />} />
      <Route path="/guest/favorites" element={<PrivateRoute Component={FavoritesPage} />} />
      {/* ======================================================
          ADMIN
          ====================================================== */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/users" element={<AdminPrivateRoute Component={AdminUsers} />} />
      <Route path="/admin/annonces" element={<AdminPrivateRoute Component={AdminAnnonces} />} />
      <Route
        path="/admin/reservations"
        element={<AdminPrivateRoute Component={AdminReservations} />}
      />
      <Route
        path="/admin/reservation/:resaId"
        element={<AdminPrivateRoute Component={AdminResaItemPage} />}
      />
      <Route path="/admin/paiements" element={<AdminPrivateRoute Component={AdminPaiements} />} />
      <Route
        path="/admin/signalements"
        element={<AdminPrivateRoute Component={AdminReportsPage} />}
      />
      <Route
        path="/admin/annonces/:annonceId"
        element={<AdminPrivateRoute Component={AdminAnnoncesItemPage} />}
      />
      <Route
        path="/admin/users/:userId"
        element={<AdminPrivateRoute Component={AdminUserItemPage} />}
      />
    </Routes>
  );
}

export default AppRoutes;
